import React, { Component } from "react";
import store from "@/redux/store";

import * as CustomerConst from "actions/customerConst";
import {FieldHolder} from "@/components/holders/FieldHolder";
import { useForm, SubmitHandler } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

interface VatProps {
    register: any;
    registerkey: string;
    data: any;
    state: any;
    [key: string]: any; //Accept any property
}

export function Vat({ ...props }: VatProps) {   




let index = 0;
let registerKey = props.registerkey;
  return (
    <>
    
                <div className="grid grid-cols-12 gap-3">
            <FieldHolder colspan="4" smcolspan="3" label="BTW nummer" id="vatid" error={props?.state?.error}>                
                  <input
                    id="vatid"
                    name="vatid"
                    type="text"
                    {...props.register(registerKey+'vatid')}
                    key={(props.data && props.data.vatid) ?? null}
                    
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            </div>
                <div className="grid grid-cols-12 gap-3">
            <FieldHolder colspan="4" smcolspan="3" label="KVK nummer" id="coc" error={props?.state?.error}>                
                  <input
                    id="coc"
                    name="coc"
                    type="text"
                    {...props.register(registerKey+'coc')}
                    key={(props.data && props.data.coc) ?? null}
                    
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            
            <FieldHolder colspan="4" smcolspan="3" label="Datum van inschrijving" id="startdate" error={props?.state?.error}>                
                  <input
                    id="startdate"
                    name="startdate"
                    type="text"
                    {...props.register(registerKey+'startdate')}
                    key={(props.data && props.data.startdate) ?? null}
                    
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>

            <FieldHolder colspan="4" smcolspan="3" label="SBI Code" id="sbi_code" error={props?.state?.error}>                
                  <input
                    id="sbi_code"
                    name="sbi_code"
                    type="text"
                    {...props.register(registerKey+'sbi_code')}
                    key={(props.data && props.data.sbi_code) ?? null}
                    
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            
            </div>
                  <div className="grid grid-cols-12 gap-3">
                  <div className="col-span-12 sm:col-span-9">
                      <label htmlFor="sbi_description" className="block text-sm font-medium leading-6 text-gray-900">
                        SBI Omschrijving
                      </label>
                      <div className="mt-2">
                        <textarea
                          id="sbi_description"
                          name="sbi_description"
                        {...props.register(registerKey+'sbi_description')}
                        key={(props.data && props.data.sbi_description) ?? null}
                          rows={4}
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                  </div>
            </div>
            
    </>
      );
}      

